import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "setup";

const initialState = {
  ProcessIDWithPercentage: [{ processID: "", percentage: 0 }],
};

export const signalRProgressSlice = createSlice({
  name: "signalRProgress",
  initialState,
  reducers: {
    setPercentage: (state, action) => {
      const processID = action.payload.split("|")[0] as string;
      const percentage = action.payload.split("|")[1] as number;
      const index = state.ProcessIDWithPercentage.findIndex((i) => i.processID === processID);
      if (index > 0) {
        state.ProcessIDWithPercentage[index].percentage = percentage;
      } else {
        state.ProcessIDWithPercentage.push({ processID, percentage });
      }
    },
  },
});

export const { setPercentage } = signalRProgressSlice.actions;

export const selectPercentage = (processID: string) => (state: RootState) =>
  state.signalRProgress.ProcessIDWithPercentage.find((i) => i.processID === processID)?.percentage;

export default signalRProgressSlice.reducer;
